import { FerramentaVideoService } from 'core/http/service/ferramentaVideo/FerramentaVideo.service';
import { IFVPackageUnit } from 'pages/ferramentaVideo/interfaces/FVPackageUnit.interface';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const service = new FerramentaVideoService();

const fetchPackage = async (id: number): Promise<IFVPackageUnit[]> => {
    const { data } = await service.fetchPackageUnitById(id);
    return data;
};

const createPackageUnit = async (idPackage: number, data: IFVPackageUnit): Promise<IFVPackageUnit> => {
    const { data: response } = await service.createPackageUnit(idPackage, data);
    return response;
};

const updatePackageUnit = async (idPackageUnit: number, data: IFVPackageUnit): Promise<IFVPackageUnit> => {
    const { data: response } = await service.updatePackageUnit(idPackageUnit, data);
    return response;
};

const deletePackageUnit = async (idPackageUnit: number): Promise<void> => {
    await service.deletePackageUnit(idPackageUnit);
};

export function useFVPackageUnit(idPackage: number) {
    const queryClient = useQueryClient();

    const listQuery = useQuery<IFVPackageUnit[]>(['packageUnits', idPackage], async ({ queryKey }) => {
        const [, id] = queryKey as [string, number];
        return fetchPackage(id);
    });

    const createPackageUnitMutation = useMutation((data: IFVPackageUnit) => createPackageUnit(idPackage, data), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnits', idPackage]);
        },
    });

    const updatePackageUnitMutation = useMutation((data: IFVPackageUnit) => updatePackageUnit(data.id, data), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnits', idPackage]);
        },
    });

    const deletePackageUnitMutation = useMutation((idPackageUnit: number) => deletePackageUnit(idPackageUnit), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnits', idPackage]);
        },
    });

    return {
        listQuery,
        createPackageUnitMutation,
        updatePackageUnitMutation,
        deletePackageUnitMutation,
    };
}
